/**
 * Atelier Mino — dates estimées en jours ouvrés (France métropolitaine, jours fériés inclus).
 * Utilisé par le bloc « Délai daté » et la section « Bandeau date limite ».
 * Tout est calculé dans le navigateur : la page reste en cache, la date reste juste.
 */
(() => {
  if (window.MinoDates) return;

  const cle = (d) => `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  const plusJours = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

  /** Dimanche de Pâques (algorithme de Meeus/Jones/Butcher). */
  function paques(an) {
    const a = an % 19, b = Math.floor(an / 100), c = an % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mois = Math.floor((h + l - 7 * m + 114) / 31), jour = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(an, mois - 1, jour);
  }

  const cacheFeries = {};
  function feries(an) {
    if (cacheFeries[an]) return cacheFeries[an];
    const p = paques(an);
    const liste = [
      new Date(an, 0, 1), plusJours(p, 1), new Date(an, 4, 1), new Date(an, 4, 8), plusJours(p, 39),
      plusJours(p, 50), new Date(an, 6, 14), new Date(an, 7, 15), new Date(an, 10, 1), new Date(an, 10, 11), new Date(an, 11, 25),
    ];
    return (cacheFeries[an] = new Set(liste.map(cle)));
  }

  const ouvre = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !feries(d.getFullYear()).has(cle(d));

  /** Ajoute n jours ouvrés ; si `depart` n'est pas ouvré, on part du prochain jour ouvré. */
  function ajouterOuvres(depart, n) {
    let d = new Date(depart.getFullYear(), depart.getMonth(), depart.getDate());
    while (!ouvre(d)) d = plusJours(d, 1);
    let restant = n;
    while (restant > 0) {
      d = plusJours(d, 1);
      if (ouvre(d)) restant -= 1;
    }
    return d;
  }

  const fmtCourt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: '2-digit', month: '2-digit' });
  const fmtLong = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });

  /** « 2026-12-14 » → Date locale (sans décalage de fuseau). */
  function lireDate(iso) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((iso || '').trim());
    return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
  }

  /** Message de date limite, ou null hors fenêtre. Le lendemain de la date limite, plus rien. */
  function messageDateLimite(limiteIso, debutIso, texte, texteDernier, aujourdhui = new Date()) {
    const limite = lireDate(limiteIso);
    if (!limite) return null;
    const auj = new Date(aujourdhui.getFullYear(), aujourdhui.getMonth(), aujourdhui.getDate());
    const debut = lireDate(debutIso);
    if (debut && auj < debut) return null;
    const jours = Math.round((limite - auj) / 86400000);
    if (jours < 0) return null;
    if (jours === 0) return texteDernier;
    return texte.replace('[date]', fmtLong.format(limite)).replace('[jours]', String(jours));
  }

  window.MinoDates = { ajouterOuvres, ouvre, fmtCourt, fmtLong, lireDate, messageDateLimite };

  if (!customElements.get('mino-delai')) {
    customElements.define('mino-delai', class extends HTMLElement {
      connectedCallback() {
        const auj = new Date();
        const expMax = ajouterOuvres(auj, Number(this.dataset.expMax) || 2);
        const exp = this.querySelector('[data-mino-exp]');
        if (exp) {
          this.querySelector('[data-mino-exp-date]').textContent = fmtCourt.format(expMax);
          exp.hidden = false;
        }
        const liv = this.querySelector('[data-mino-liv]');
        if (liv) {
          const min = ajouterOuvres(expMax, Number(this.dataset.livMin) || 2);
          const max = ajouterOuvres(expMax, Number(this.dataset.livMax) || 5);
          liv.textContent = `entre le ${fmtCourt.format(min)} et le ${fmtCourt.format(max)}`;
        }
        const noel = this.querySelector('[data-mino-noel]');
        if (noel && this.dataset.dateLimite) {
          const msg = messageDateLimite(this.dataset.dateLimite, this.dataset.dateLimiteDebut,
            'Pour Noël, commandez avant le [date].', 'Pour Noël : dernier jour pour commander.');
          if (msg) { noel.textContent = msg; noel.hidden = false; }
        }
      }
    });
  }
})();
